import axios from '@/components/api/axios';

async function getGyronpayParameter() {
  const res = await axios.axiosGet('/api/gyronpay/getParameter', null);
  return res;
}

export default {
  getGyronpayParameter,

}



// WEBPACK FOOTER //
// ./src/components/api/gyronpay.js